module.exports = __webpack_public_path__ + "static/media/igra.7522f15e.jpg";